import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Image = styled('img')({
  width: '100%',
  height: '100%',
  minHeight: 120,
  display: 'block',
  objectFit: 'contain',
});
